export const definedPostalCodes = [
  {
    countryCode: 'CA',
    validationRegex: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
  },
  {
    countryCode: 'US',
    validationRegex: /^\d{5}(?:-\d{4})?$/,
  },
];
